import {
    BankingAccountType,
    formatDate, ProviderApi,
    // @ts-expect-error - banking is deprecated
    ProviderBankingAccount,
    ProviderIntegrationApi, ProviderIntegrationHl7, ProviderIntegrationSftp,
    ProviderPlaidItemInfo,
    ProviderUser,
    Role
} from '@enter/core';
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { RootStore } from './root.store';
import { waitForNoReason } from './util';

export class SettingsGenerator {
    public users: ProviderUser[] = [];
    public roles: Role[] = [];

    public integrationApis: ProviderIntegrationApi[] = [];

    public integrationHl7s: ProviderIntegrationHl7[] = [];

    public integrationSftps: ProviderIntegrationSftp[] = [];

    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        this.generateEntities(10);
        this.generateRoles();
    }

    public async listProviderUsers(): Promise<ProviderUser[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return this.users;
    }

    public async listProviderIntegrationApis(): Promise<ProviderIntegrationApi[]> {
        await waitForNoReason(100);
        return this.integrationApis;
    }

    public async listProviderIntegrationSftps(): Promise<ProviderIntegrationSftp[]> {
        await waitForNoReason(100);
        return this.integrationSftps;
    }

    public async listProviderIntegrationHl7s(): Promise<ProviderIntegrationApi[]> {
        await waitForNoReason(100);
        return this.integrationHl7s;
    }

    public async listProviderRoles(): Promise<Role[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return this.roles;
    }

    public async listProviderBankingAccounts(): Promise<ProviderBankingAccount[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return [
            {
                id: faker.string.uuid(),
                name: 'Plaid Gold Standard 0% Interest Checking',
                nickname: 'Plaid Checking',
                institutionName: 'Bank of America',
                account: faker.number.int({ max: 1000000000 }).toString(),
                routing: faker.number.int({ max: 1000000000 }).toString(),
                wire: faker.number.int({ max: 1000000000 }).toString(),
                holderName: `${faker.person.firstName()} ${faker.person.lastName()}`,
                accountType: BankingAccountType.CHECKING,
                forPaymentDeposits: true,
                forFeeCharges: true,
                forMonitoring: true,
                verified: true,
                active: true,
                created: formatDate('Date')(faker.date.past()),
            },
        ];
    }

    public async listPlaidItems(): Promise<ProviderPlaidItemInfo[]> {
        await waitForNoReason(400); // add some lag so loader appears
        return [
            {
                plaidItemId: faker.string.uuid(),
                externalItemId: faker.string.alphanumeric(30),
                externalInstitutionId: 'ins_127989',
                institutionName: 'Bank of America',
                accounts: [
                    {
                        name: 'Business Adv Relationship',
                        type: 'DEPOSITORY',
                        subtype: 'CHECKING',
                        mask: '5060',
                    },
                ],
            },
            {
                plaidItemId: faker.string.uuid(),
                externalItemId: faker.string.alphanumeric(30),
                externalInstitutionId: 'ins_3',
                institutionName: 'Chase',
                accounts: [
                    {
                        name: 'Chase Sapphire Reserve',
                        type: 'CREDIT',
                        subtype: 'CREDIT_CARD',
                        mask: '4567',
                    },
                    {
                        name: 'Chase Total Checking',
                        type: 'DEPOSITORY',
                        subtype: 'CHECKING',
                        mask: '8901',
                    },
                ],
            },
        ];
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderUser());
    }

    private generateProviderUser(userId: string = faker.string.uuid()): ProviderUser {
        const user: ProviderUser = {
            userId,
            created: formatDate('Date')(faker.date.past()),
            first: faker.person.firstName(),
            last: faker.person.lastName(),
            phone: faker.phone.number(),
            email: faker.internet.exampleEmail(),
            roles: [{ accountId: this.rootStore.account?.grantedAccountId, roleId: 'PROVIDER_ADMIN_ACCESS' }],
        };

        this.users.push(user);
        return user;
    }

    private generateRoles(): void {
        const roles: Role[] = [
            {
                roleId: 'PROVIDER_ADMIN_ACCESS',
                name: 'Admin Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
            {
                roleId: 'PROVIDER_READ_ACCESS',
                name: 'Read-Only Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
            {
                roleId: 'PROVIDER_READ_WRITE_ACCESS',
                name: 'Read-Write Access',
                application: 'PROVIDER_DASHBOARD',
                isPublic: true,
            },
        ];

        this.roles = roles;
    }
}
